import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'sb-entries-info',
    imports: [TranslateModule],
    templateUrl: './entries-info.component.html',
    styleUrl: './entries-info.component.scss',
})
export class EntriesInfoComponent {
    @Input() activePage: number;
    @Input() itemCount: number;
    @Input() pageSize: number;
}
